import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import { loadDecrypted } from "Common Usage/localStorageUtils";

const AuthCheck = ({ setIsLoading, layoutType }) => {
  let navigate = useNavigate();

  useEffect(() => {
    const token = loadDecrypted("HeartConnect-AuthToken");
    setTimeout(() => {
      if (layoutType === "admin" && !token) {
        navigate("/auth/sign-in");
      } else if (layoutType === "auth" && token) {
        navigate("/admin/dashboard");
      } else if (layoutType === "initialRender") {
        if (!token) {
          navigate("/auth/sign-in");
        } else {
          navigate("/admin/dashboard");
        }
      } else {
        setIsLoading(false);
      }
    }, 1000);
  }, [layoutType, navigate, setIsLoading]);
  return <Loader />;
};
export default AuthCheck;
